import { BackendErrorWithMessageError, FieldError } from '@pct-ng/core/error-http';
import type { BackendErrorWithMessage } from '../model/backend-error-with-message';

export function hasErrorCode(error: any, errorCode: string): boolean {
  return errorToStrId(error).includes(errorCode);
}

export function errorToStrId(error: any): string[] {
  if (error instanceof FieldError) {
    const fieldError = error as FieldError<BackendErrorWithMessage['errors']>;
    return fieldError.fieldErrors.map(err => err.strId);
  }

  if (error instanceof BackendErrorWithMessageError) {
    const backendErrors = error.backendError.errors;
    if (Array.isArray(backendErrors)) {
      return backendErrors.map(err => err.strId);
    }
  }

  return [];
}
